var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v15.06a1 1 0 0 1-1.58.814L10 15.725l-4.42 3.149A1 1 0 0 1 4 18.06V3z"
  })));
};
export default SvgBookmark;